export default __webpack_public_path__ + "static/media/abp.2651079b.png";